import { ComponentProps } from 'react';

import { Volume } from '~/shared/types/api';
import { convertToGIB } from '~/shared/utils/formatNumber';
import Tag from '~/shared/components/Tag';

export const statusToTagVariantMap: {
  [k in Volume['monitoring']]: ComponentProps<typeof Tag>['variant'];
} = {
  Managed: 'green',
  Migrating: 'green',
  Unmonitored: 'gray',
  Unmanaged: 'gray',
  Unmigrating: 'gray',
  Growing: 'purple',
  Shrinking: 'purple',
  Merging: 'purple',
  Unattached: 'dark-blue',
  Deleted: 'dark-blue',
  Monitored: 'cyan',
};

export const refetchIntervalMs = 5000;

export function getProvisionedUtilization(volume?: Volume) {
  const { diskUsed, diskSize } = volume || {};

  const utilizationPercent = diskSize && diskUsed ? Math.round((diskUsed / diskSize) * 100) : 0;

  return `${utilizationPercent}% (${convertToGIB(diskUsed || 0)})`;
}

export function getDatafyUtilization(volume?: Volume) {
  const { diskUsed, datafyDiskSize } = volume || {};

  const utilizationPercent =
    datafyDiskSize && diskUsed ? Math.round((diskUsed / datafyDiskSize) * 100) : 0;

  return `${utilizationPercent}% (${convertToGIB(diskUsed || 0)})`;
}

export function getFilterSearchParams(
  filters: {
    field: 'monitoring' | 'sourceVolume' | 'volumeId' | 'instanceId' | 'diskType';
    value: string;
    op: 'equals';
  }[]
) {
  return [
    ...filters.map(({ field, value, op }) => ['filters', JSON.stringify({ field, value, op })]),
  ];
}

export const datafyDevelopmentTenantId = [
  '79c406c5-7b64-43f2-ba76-9b01e74e3d90',
  'c7503430-6ffd-4625-87a8-2acc7979e198',
];
